import {Copy, RotateCcw} from 'lucide-react'

interface CalculatorActionsProps {
  onReset: () => void
  onCopy: () => void
  copied: boolean
}

function CalculatorActions({ onReset, onCopy, copied }: CalculatorActionsProps) {
  return (
    <div className="flex flex-wrap gap-3 mt-2">
      <button
        type="button"
        onClick={onCopy}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold bg-slate-900 text-white hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 transition-colors"
      >
        <Copy className="h-4 w-4" aria-hidden="true" />
        {copied ? 'Copied!' : 'Copy Results'}
      </button>
      <button
        type="button"
        onClick={onReset}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold border border-slate-300 text-slate-700 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 transition-colors"
      >
        <RotateCcw className="h-4 w-4" aria-hidden="true" />
        Reset
      </button>
    </div>
  )
}

export default CalculatorActions
